<p-timeline [value]="estimacionesMostradas" [layout]="layout" styleClass="timeline-regulares ">
    <ng-template pTemplate="marker" let-event>
        <span class="shadow-2 p-timeline-event-marker font-semibold" 
        [ngClass]="event.cercaDeParada ? 'fadein animation-delay-500 animation-duration-3000 animation-iteration-infinite' : ''"
            [style.borderColor]="getColorStep(event)"
            [style.color]="getDesfaseColor(event.desfase)">
            <!-- {{getCalcDesfase(event.desfMedia)}} -->
            {{event.numorden}}
        </span>
    </ng-template>
    <ng-template pTemplate="content" let-item>
        {{item.hora_paso | date : 'H:mm'}} - {{item.nomparada}}
      
    </ng-template>
</p-timeline>